export default __webpack_public_path__ + "static/media/whatsapp.f77c58ca.png";